import { SelectDatesPage } from './../../../modal-screens/select-dates/select-dates.page';
import { DateRangePicker } from 'src/app/shared/date-range-picker.component';
import {
  ModalController,
  AlertController,
  NavParams,
  ToastController,
  Platform,
  PopoverController,
  LoadingController,
} from '@ionic/angular';
import { ClubInfo, createClubInfo, createCourseInfo } from 'src/data/club-course';
import { Component, Input, OnInit } from '@angular/core';
import { CountryListPage } from './../../../modal-screens/country-list/country-list.page';
import { CalendarComponentOptions } from 'ion2-calendar';
import * as moment from 'moment';
import { RecentClubPage } from 'src/app/pages/performance/recent-club/recent-club.page';
import { ClubListPage } from 'src/app/pages/normalgame/club-list/club-list.page';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { NavigationExtras, Router } from '@angular/router';
import { PlayerFavouriteListPage } from 'src/app/pages/player-favourite-list/player-favourite-list.page';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { MoreMenuPopoverComponent } from '../../booking-details/more-menu-popover/more-menu-popover.component';
import { DeleteRoomModalComponent } from 'src/app/pages/package-details/package-booking/delete-room-modal/delete-room-modal.component';
import {
  ClubTeeTimeSlots,
  DiscountCompany,
  FindTeeTimeCriteria,
  TeeTimeClubVoucher,
} from 'src/data/mygolf.data';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/player-data';
import { BookingService } from 'src/providers/tee-booking-service/tee-booking-service';
import { isPresent } from 'src/providers/common-service';
import { Location } from '@angular/common';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';

@Component({
  selector: 'app-search-tee-time',
  templateUrl: './search-tee-time.component.html',
  styleUrls: ['./search-tee-time.component.scss'],
})
export class SearchTeeTimeComponent implements OnInit {
  startDate: any;
  fromTime: any;
  toTime: any;
  filterCountry: any;
  selectClubType: string = 'allClubs';
  @Input() isClubSpecific: any;
  @Input() userType: string = 'player';
  @Input() countryList: any;
  @Input() filteredLocation: any;
  @Input() courseInfo: any;
  @Input() courseType: any = 'club';
  searchDistance: number = 50;
  @Input() clubInfo: any;
  @Input() appAttribute: any;
  @Input() botsOut: any;
  @Input() captchaResponse: any;

  today: string;

  @Input() partnerInfo: DiscountCompany;
  @Input() favClubs: Array<any>;
  @Input() selectedClub: any;
  @Input() currentPlayer: any;
  searchCriteria: FindTeeTimeCriteria;
  playerHomeInfo$: Observable<PlayerHomeInfo>;
  player$: Observable<PlayerInfo>;
  constructor(
    private modalCtl: ModalController,
    private flightService: ClubFlightService,
    private router: Router,
    private alertCtrl: AlertController,
    private navParams: NavParams,
    private platform: Platform,
    private toastCtl: ToastController,
    private popoverCtl: PopoverController,
    private loadingCtrl: LoadingController,
    private mg2uUtils: mygolfUtils,
    private bookingService: BookingService,
    private location: Location,
    private playerService: PlayerService,
    private playerHomeService: PlayerHomeDataService,
    private geo: GeolocationService
  ) {
    console.debug('init search tee time ', this.appAttribute, this.navParams.get('appAttribute'));
    this.appAttribute = this.navParams.get('appAttribute');
    this.today = moment().format('YYYY-MM-DD');

    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
    }

    this.selectedClub = this.mg2uUtils.getSelectedClub();
    this.isClubSpecific = this.mg2uUtils.getClubSpecific();

    let _param = this.platform.getQueryParam('param');
    if (_param) {
      this.selectedClub = this.navParams.get('club');
    } else if (!_param && this.mg2uUtils.getClubMembership()) {
      this.selectedClub = this.mg2uUtils.getClubMembership().club;
    }
  }

  async ngOnInit() {
    await Promise.all([
      this.initSearchCriteria(),
      this.getAppAttribute(),
      this.refreshFavouriteClubs(),
    ]);
    this.courseInfo = createCourseInfo();
    // this.getAppAttribute();
    // this.initSearchCriteria();
    // this.refreshFavouriteClubs();

    if (this.isClubSpecific) {
      this.selectClubType = 'single';
      this.courseType = 'club';

      console.debug(
        'init is club spec : ',
        this.selectedClub,
        this.mg2uUtils.getSelectedClub(),
        this.mg2uUtils.getClubMembership()
      );
      if (this.mg2uUtils.getAppTypeClub()) this.clubInfo = this.mg2uUtils.getHomeClub();
      else if (this.platform.getQueryParam('param')?.length)
        this.clubInfo = this.mg2uUtils.getClubMembership().club;
      else this.clubInfo = this.selectedClub;
      this.courseInfo = createCourseInfo();
    }
  }

  async initSearchCriteria() {
    console.debug('on init [0] ', this.searchCriteria, this.bookingService.getSearch());
    this.searchCriteria = await this.bookingService.getSearch();
    console.debug('on init [1] ', this.searchCriteria, this.bookingService.getSearch());
    console.debug(
      'on init [2] ',
      moment(this.searchCriteria?.startDate, 'YYYY-MM-DD').isSameOrBefore(moment(), 'day')
    );
    console.debug('on init [3] ', moment(this.searchCriteria?.startDate, 'YYYY-MM-DD'), moment());
    console.debug('on init [4] ', moment().add(1, 'd').format('YYYY-MM-DD'));
    console.debug('on init [5] ', isPresent(this.searchCriteria?.startDate));

    if (this.searchCriteria || this.bookingService.getSearch()) {
      if (isPresent(this.searchCriteria?.startDate)) {
        if (moment(this.searchCriteria?.startDate, 'YYYY-MM-DD').isSameOrBefore(moment(), 'day')) {
          this.searchCriteria.startDate = moment().add(1, 'd').format('YYYY-MM-DD');
          this.startDate = moment().add(1, 'd').format('YYYY-MM-DD');
          this.bookingService.setSearch(this.searchCriteria);
        } else if (this.searchCriteria.startDate) this.startDate = this.searchCriteria.startDate;
        else this.startDate = moment().add(1, 'd').format('YYYY-MM-DD');
      }
      this.fromTime = this.searchCriteria?.fromTime || '07:00';
      this.toTime = this.searchCriteria?.toTime || '19:00';
      this.filterCountry = this.searchCriteria?.filterCountry || null;
      this.selectClubType = this.searchCriteria?.selectClubType || 'allClubs';

      // if(this.selectClubType === 'single') {
      this.clubInfo = this.searchCriteria?.clubInfo;
      // } else if(this.selectClubType === 'nearbyClubs') {
      this.searchDistance = this.searchCriteria?.searchDistance || 50;
      // } else if(this.selectClubType === 'location') {
      this.filteredLocation = this.searchCriteria?.filteredLocation;
      // }
    }
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null || flagUrl == '') return '/assets/img/flag/default_worldwide.png';
    else {
      let flagIcon = flagUrl.split('/');
      return '/assets/img/flag/' + flagIcon[2];
    }
  }

  getCountryInfo() {
    if (!this.filterCountry) return 'All Countries';
    else return this.filterCountry && this.filterCountry.name;
  }

  clearClubSelection() {
    this.clubInfo = createClubInfo();
  }

  async onSelectCountry(type?: string) {
    const modal = await this.modalCtl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName: 'Select Country',
        excludeAll: false,
      },
    });
    modal.onDidDismiss().then((country?: any) => {
      const _country = country.data;
      if (!country || country === -999) this.filterCountry = null;
      else this.filterCountry = _country;
      this.clearClubSelection();
    });

    await modal.present();
  }

  async openDateModal() {
    const calendarOptions: CalendarComponentOptions = {
      from: new Date(),
      // from: this.startDate ? moment(this.startDate).startOf('day').toDate() : new Date(),
      to: 0,
      pickMode: 'single',
    };
    const modal = await this.modalCtl.create({
      component: DateRangePicker,
      componentProps: {
        selectedDate: this.startDate,
        optionsRange: calendarOptions,
      },
    });

    await modal.present();

    modal.onDidDismiss().then(data => {
      if (data.data) this.startDate = moment(data.data?.selectedDate).format('YYYY-MM-DD');
    });
  }

  async onSelectTimes() {
    const modal = await this.modalCtl.create({
      component: SelectDatesPage,
      componentProps: {
        type: 'times',
        range: true,
        fromTime: this.fromTime,
        toTime: this.toTime,
      },
      id: 'SelectDatesPage',
    });

    modal.onDidDismiss().then(res => {
      if (res.data) {
        this.fromTime = res.data.fromTime;
        this.toTime = res.data.toTime;
      }
    });
    modal.present();
  }

  async onSelectClub() {
    if (this.isClubSpecific) return;
    let modal = await this.modalCtl.create({
      component: ClubListPage,
      componentProps: {
        openedModal: true,
        forMembership: true,
        filteredClubType: 'golfClub',
        countryId: this.filterCountry?.id,
        hideClubType: true,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('add club competition [0] ', data);
      if (!!data) {
        this.clubInfo = data.data;
        this.courseInfo = createCourseInfo();
      } else {
        this.modalCtl.dismiss(false);
        // this.cancelGroup();
      }
    });
    modal.present();
  }

  async goCoursePicklist() {
    if (this.isClubSpecific) return;
    let _courseId;
    let _courseName;
    if (1 || this.userType === 'booking_agent') {
      this.onClubPicklist()
        .then((result: any) => {
          if (result && result.status === 'success') {
            this.clubInfo = result.clubInfo;
            this.courseInfo = createCourseInfo();
            // this.nav.push(TeeTimeSlotsPage, {
            //     clubId: result.clubInfo.clubId,
            //     fromClub: true,
            // })
          }

          // if (!data) {
          //     return false;
          // }
          // if (data.apply) {
          //     this.courseInfo = data.courseInfo;
          //     this.clubInfo = data.clubInfo;

          //     // this.clubName = clubName;
          //     // this.clubName = clubInfo.clubName;
          //     _courseId = this.courseInfo.courseId;
          //     _courseName = this.courseInfo.courseName;
          // }
        })
        .catch(error => {});
    } else if (1) {
      // this.nav.push(PerformanceClubListPage);
      /*, {
       courseId: this.courseId,
       courseName: this.courseName
       });*/
      console.log(this.clubInfo);

      const club: any = await this.modalCtl.create({
        component: RecentClubPage,
        componentProps: {
          //analysisType: "analysis",
          courseInfo: this.courseInfo,
          openedModal: true,
          courseType: this.courseType,
          clubInfo: this.clubInfo,
          recentClubType: 'Bookings',
        },
        id: 'RecentClubPage',
      });

      if (this.courseType == 'course') {
        club.onDidDismiss().then((data: any) => {
          if (!data) {
            return false;
          }
          if (data.apply) {
            this.courseInfo = data.courseInfo;
            this.clubInfo = data.clubInfo;

            // this.clubName = clubName;
            // this.clubName = clubInfo.clubName;
            _courseId = this.courseInfo.courseId;
            _courseName = this.courseInfo.courseName;
          }
        });
      } else if (this.courseType == 'club') {
        club.onDidDismiss().then((data: any) => {
          let cnt = 0;
          if (data.data.clubInfo) {
            this.clubInfo = data.data.clubInfo;
            cnt++;
          }
          if (cnt == 0) {
            this.clubInfo = data.data;
          }
          this.courseInfo = createCourseInfo();
          // this.clubName = this.clubInfo.clubName;
        });
      }
      club.present();
    } else {
      _courseId = null;
      _courseName = 'Please choose a course';
    }
  }

  onClubPicklist() {
    return new Promise(async (resolve, reject) => {
      let clubId;
      console.debug('on club picklist : ', this.filterCountry);
      let club = await this.modalCtl.create({
        component: ClubListPage,
        componentProps: {
          countryId: this.filterCountry ? this.filterCountry.id : null,
          openedModal: true,
          hideClubType: true,
        },
      });

      club.onDidDismiss().then((data: any) => {
        if (data) {
          clubId = data?.data?.clubId;
          // this.getClubSession(data.clubId);
        }
        // else {
        //     this.onClubPicklist();
        // }
        if (!clubId) {
          reject({
            status: 'failed',
            message: 'No Club Id provided',
          });
        } else if (clubId) {
          this.flightService.getClubInfo(clubId).subscribe((data: ClubInfo) => {
            if (data) {
              resolve({
                status: 'success',
                message: 'club info',
                clubInfo: data,
              });
            }
          });
        }
      });
      club.present();
    });
  }
  getClubName(): string {
    let clubName = 'Tap here to select club';
    if (this.clubInfo && this.clubInfo.clubName) return this.clubInfo.clubName;
    else if (this.clubInfo && this.clubInfo.name) return this.clubInfo.name;
    else return clubName;
  }

  backRouting() {
    let _params: NavigationExtras = {
      replaceUrl: false,
    };
    this.router.navigate(['tabs/player-home'], _params);
    // this.location.back();
  }

  dismiss(save: boolean = false) {
    if (1) {
      this.backRouting();
      return;
    }
    if (save) {
      this.modalCtl.dismiss({
        startDate: this.startDate,
        fromTime: this.fromTime,
        toTime: this.toTime,
        filterCountry: this.filterCountry,
        selectClubType: this.selectClubType,
        isClubSpecific: this.isClubSpecific,
        filteredLocation: this.filteredLocation,
        courseInfo: this.courseInfo,
        courseType: this.courseType,
        searchDistance: this.searchDistance,
        clubInfo: this.clubInfo,
      });
    } else {
      this.modalCtl.dismiss();
    }
  }

  onClickSearch() {
    if (!isPresent(this.searchCriteria) || !this.searchCriteria) this.initSearchCriteria();
    console.debug('click search', this.searchCriteria, this.clubInfo);
    console.debug('click search', this.startDate, this.fromTime, this.toTime, this.selectClubType);
    if (this.selectClubType === 'nearbyClubs' && this.searchDistance <= 0) {
      MessageDisplayUtil.showErrorToast(
        'Please specify Search Distance more than 0 KM',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return;
    }
    if (this.selectClubType === 'single' && !this.clubInfo && !this.searchCriteria?.clubInfo) {
      MessageDisplayUtil.showErrorToast(
        'Please select a Club',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return;
    }
    if (
      this.selectClubType === 'location' &&
      (!this.filteredLocation || this.filteredLocation?.length === 0)
    ) {
      MessageDisplayUtil.showErrorToast(
        'Please specify a Location name',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return;
    }
    if (this.startDate) this.searchCriteria.startDate = this.startDate;
    if (this.fromTime) this.searchCriteria.fromTime = this.fromTime;
    if (this.toTime) this.searchCriteria.toTime = this.toTime;
    if (this.selectClubType) {
      this.searchCriteria.selectClubType = this.selectClubType;
      this.searchCriteria.searchDistance = 50;
      if (this.selectClubType === 'nearbyClubs') {
        if (this.searchDistance) this.searchCriteria.searchDistance = this.searchDistance;

        this.filteredLocation = '';
        this.searchCriteria.filteredLocation = '';
        this.clubInfo = null;
        this.searchCriteria.clubInfo = null;
      } else if (this.selectClubType === 'single') {
        if (this.clubInfo) this.searchCriteria.clubInfo = this.clubInfo;
        if (this.clubInfo) this.searchCriteria.clubId = this.clubInfo?.clubId || this.clubInfo?.id;

        this.filteredLocation = '';
        this.searchCriteria.filteredLocation = '';
      } else if (this.selectClubType === 'location') {
        if (this.filteredLocation) this.searchCriteria.filteredLocation = this.filteredLocation;
      } else if (this.selectClubType === 'recentClubs') {
        this.filteredLocation = '';
        this.searchCriteria.filteredLocation = '';
        this.clubInfo = null;
        this.searchCriteria.clubInfo = null;
      } else if (this.selectClubType === 'allClubs') {
        this.filteredLocation = '';
        this.searchCriteria.filteredLocation = '';
        this.clubInfo = null;
        this.searchCriteria.clubInfo = null;
      }
    }
    if (this.filterCountry) this.searchCriteria.filterCountry = this.filterCountry;

    this.bookingService.setSearch(this.searchCriteria);

    this.goSearchTeeTimes();
    // use promise -> error messsages
    // go to booking-club-list or booking-list
  }

  quickBook() {
    if (!this.clubInfo) {
      let _message = 'Please select a club';
      let alert = this.alertCtrl
        .create({
          header: 'Quick book option',
          message: _message,
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
        });
      return false;
    }
    let _data = {
      mode: 'quickBook',
      startDate: this.startDate,
      fromTime: this.fromTime,
      toTime: this.toTime,
      filterCountry: this.filterCountry,
      selectClubType: this.selectClubType,
      isClubSpecific: this.isClubSpecific,
      filteredLocation: this.filteredLocation,
      courseInfo: this.courseInfo,
      courseType: this.courseType,
      searchDistance: this.searchDistance,
      clubInfo: this.clubInfo,
    };
    this.modalCtl.dismiss({ data: _data, role: 'quickBook' });
  }

  getCurrentLocation() {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
  }

  async setupFavClubs() {
    // this.router.navigate(['player-favourite-list']);
    const modal = await this.modalCtl.create({
      component: PlayerFavouriteListPage,
      cssClass: 'search-tee-time-modal',
      componentProps: {
        isFromModal: true,
      },
    });
    modal.present();
  }

  disableQuickbook() {
    if (this.appAttribute && this.appAttribute.disableQuickbook) return true;
    else return false;
  }

  resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
    if (this.captchaResponse.length > 0) this.quickBook();
  }

  addDate(value) {
    // if(value < 0)
    let _date = this.startDate;
    _date = moment(_date).add(value, 'd').format('YYYY-MM-DD');
    console.log('startDate add', this.startDate + ' adds ' + value);
    if (_date < this.today) {
      MessageDisplayUtil.showMessageToast(
        'Selecting earlier date is not allowed',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return;
    }
    this.startDate = _date;
  }

  async onClickMoreMenu() {
    let moreMenuItemLists = [
      { label: 'My Bookings', value: 'my_booking' },
      // { label: 'Cancel Booking', value: 'cancel_booking' },
    ];

    let popover = await this.popoverCtl.create({
      component: MoreMenuPopoverComponent,
      event: event,
      mode: 'ios',
      cssClass: 'popoverWidth',
      componentProps: {
        moreMenuItemLists: moreMenuItemLists,
      },
    });
    popover.present();
    await popover.onDidDismiss().then(data => {
      if (data?.data) {
        switch (data?.data) {
          case 'my_booking':
            this.goToMyBookings();
            break;
        }
      }
    });
  }

  goToMyBookings() {
    let _isClubSpecific;
    let _club;
    if (this.isClubSpecific) {
      // if (this.hasParam) _club = this.selectedClub;
      // else if(this.homeClubMembership) _club = this.homeClubMembership.club;
      // else if(this.selClubMembership) _club = this.selClubMembership.club;
      // _isClubSpecific = this.isClubSpecific;
    } else {
      _isClubSpecific = false;
      _club = null;
    }
    let params: NavigationExtras = {
      state: {
        userType: 'player',
        isClubSpecific: _isClubSpecific,
        club: _club,
        clubSpecificThemes: this.appAttribute.clubSpecificThemes,
      },
    };
    // this.modalCtl.dismiss().then(()=>{
    this.router.navigate(['booking-home'], params);
    // });
  }

  async goSearchTeeTimes() {
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
      backdropDismiss: true,
      // dismissOnPageChange
      // duration: 5000,
    });
    let _favClubs;
    let navigationExtras: NavigationExtras;
    let _countryId = this.filterCountry ? this.filterCountry.id : null;
    let _location = this.filteredLocation;
    if (this.selectClubType === 'single' && (!this.clubInfo || !this.courseInfo)) {
      let _message = 'Please select a single club';
      let alert = this.alertCtrl
        .create({
          header: 'Search option',
          message: _message,
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
        });
      return false;
    } else if (
      this.selectClubType === 'favClubs' &&
      ((this.favClubs && this.favClubs.length === 0) || !this.favClubs)
    ) {
      let _message = 'No Favourite clubs found. Please tap on SET UP to define your favourites.';
      let alert = this.alertCtrl
        .create({
          header: 'Search by Favourite Club(s)',
          // subTitle: 'Selected date is '+ _date,
          message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
        });
      return false;
    } else if (
      this.selectClubType === 'location' &&
      ((this.filteredLocation && this.filteredLocation.length === 0) || !this.filteredLocation)
    ) {
      let _message = 'Please enter a location name';
      let alert = await this.alertCtrl.create({
        header: 'Search by Location',
        // subTitle: 'Selected date is '+ _date,
        message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
        buttons: ['Close'],
      });
      alert.present();
      return false;
    }
    let _forDate = moment(this.startDate).format('YYYY-MM-DD');
    let _fromTime = this.fromTime; //'07:00';
    let _toTime = this.toTime; //'09:00';
    let _clubCourseId;
    let _isClub: boolean = true;
    loader.present().then(() => {
      let _bookingListType = this.selectClubType; //'single';

      let _playerId;
      if (this.userType === 'player')
        this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
          _playerId = player.playerId;
        });
      if (_bookingListType === 'single') {
        if (this.courseType === 'club') {
          _clubCourseId = this.clubInfo.clubId;
          _isClub = true;
        } else if (this.courseType === 'course') {
          _clubCourseId = this.courseInfo.courseId;
          _isClub = false;
        }
        let _pageSize;
        let _partnerId = this.partnerInfo ? this.partnerInfo.id : null;
        // loader.dismiss().then(() => {
        this.flightService
          .getSearchAllSlots(
            _forDate,
            _fromTime,
            _toTime,
            _pageSize,
            null,
            _partnerId,
            _clubCourseId,
            _countryId,
            null,
            _location
          )
          // .subscribe((teeTimeSlotDayDisplay: Array<TeeTimeSlotDisplay>) => {
          .subscribe(
            async (data: any) => {
              let teeTimeSlotDayDisplay;
              let _slotStats = data.resp;
              if (_slotStats && _slotStats.totalPages === 0) {
                console.debug(
                  'search all slots : ',
                  this.selectedClub,
                  this.clubInfo,
                  this.isClubSpecific
                );
                let _clubName = this.clubInfo?.name || this.clubInfo?.clubName;
                let _message =
                  _clubName +
                  '<br>Date : ' +
                  moment(_forDate).format('ddd, DD MMM YYYY') +
                  '<br>From ' +
                  _fromTime +
                  ' to ' +
                  _toTime;
                if (this.filterCountry && this.filterCountry.name)
                  _message += '<br>Country : ' + this.filterCountry.name;
                // if(teeTimeSlotDayDisplay && teeTimeSlotDayDisplay.length > 0) {
                //     if( teeTimeSlotDayDisplay[0].reasonsForUnavailability[0])
                //         _message += '<br>' + teeTimeSlotDayDisplay[0].reasonsForUnavailability[0]
                // }
                let alert = await this.alertCtrl.create({
                  header: 'No Tee Time slots',
                  // subTitle: 'Selected date is '+ _date,
                  message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
                  buttons: ['Close'],
                });
                alert.present();
                // if (this.loader) this.loader.dismiss();
                return false;
              }

              if (data.teeTimeSlot) teeTimeSlotDayDisplay = data.teeTimeSlot[0].slots; //teeTimeSlotDayDisplay
              // this.loader.dismiss().then(()=>{

              let _hasAvailable;
              if (teeTimeSlotDayDisplay && teeTimeSlotDayDisplay.length > 0)
                _hasAvailable = teeTimeSlotDayDisplay.find(slots => {
                  return slots.available;
                });

              if (
                teeTimeSlotDayDisplay.length > 0 &&
                ((_hasAvailable && _hasAvailable.available) ||
                  this.mg2uUtils.getUserType() === 'booking_agent')
              ) {
                navigationExtras = {
                  state: {
                    bookingListType: _bookingListType,
                    teeTimeSlotDisplayList: teeTimeSlotDayDisplay,
                    fromTime: _fromTime,
                    toTime: _toTime,
                    startDate: _forDate,
                    courseInfo: this.courseInfo,
                    clubInfo: this.clubInfo,
                    fromClub: false,
                    userType: this.userType,
                    partnerInfo: this.partnerInfo,
                    clubTeeTimeSlotList: data.teeTimeSlot[0],
                    totalPages: _slotStats.totalPages,
                  },
                };
                this.router.navigate(['booking-list'], navigationExtras);
              } else {
                let _message =
                  this.clubInfo.clubName +
                  '<br>Date : ' +
                  moment(_forDate).format('ddd, DD MMM YYYY') +
                  '<br>From ' +
                  _fromTime +
                  ' to ' +
                  _toTime;
                if (teeTimeSlotDayDisplay && teeTimeSlotDayDisplay.length > 0) {
                  if (teeTimeSlotDayDisplay[0].reasonsForUnavailability[0])
                    _message += '<br>' + teeTimeSlotDayDisplay[0].reasonsForUnavailability[0];
                }
                let alert = await this.alertCtrl.create({
                  header: 'No Tee Time slots',
                  // subTitle: 'Selected date is '+ _date,
                  message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
                  buttons: ['Close'],
                });
                alert.present();
              }
              if (loader) loader.dismiss().then(() => {});
              // })
            },
            error => {
              if (loader) loader.dismiss().then(() => {});
            },
            () => {
              if (loader) loader.dismiss().then(() => {});
              // setTimeout(()=>{
              //     this.loader.dismiss()
              // }, 5000)
            }
          );
        // });
      } else if (_bookingListType === 'nearbyClubs') {
        let lat1 = this.geo.getLatitude();
        let lon1 = this.geo.getLongitude();

        if (lat1 === null || lon1 === null) {
          MessageDisplayUtil.showMessageToast(
            'GPS co-ordinates are not provided. Please make sure location service is on',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          if (loader) loader.dismiss().then(() => {});
          return false;
        } else {
          loader.dismiss().then(() => {
            this.flightService
              .getTeeTimeSlotNearbyClubs(_forDate, this.searchDistance, _fromTime, _toTime)
              .subscribe(
                (clubTeeTimeSlots: Array<ClubTeeTimeSlots>) => {
                  if (clubTeeTimeSlots.length > 0) {
                    if (clubTeeTimeSlots)
                      clubTeeTimeSlots.sort((a, b) => {
                        if (a.distance < b.distance) return -1;
                        else if (b.distance < a.distance) return 1;
                        else return 0;
                      });
                    if (this.mg2uUtils.getUserType() === 'booking_agent') {
                      navigationExtras = {
                        state: {
                          bookingListType: _bookingListType,
                          clubTeeTimeSlotList: clubTeeTimeSlots,
                          fromTime: _fromTime,
                          toTime: _toTime,
                          startDate: _forDate,
                          courseInfo: this.courseInfo,
                          clubInfo: this.clubInfo,
                          playerId: _playerId,
                          fromClub: false,
                          searchDistance: this.searchDistance,
                          filterCountry: this.filterCountry,
                          filteredLocation: this.filteredLocation,
                        },
                      };
                      this.router.navigate(['booking-club-list'], navigationExtras);
                      if (loader) loader.dismiss();
                    } else {
                      this.flightService
                        .getListPlayerVouchers(_playerId)
                        .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
                          if (playerVoucher && playerVoucher.length > 0) {
                            navigationExtras = {
                              state: {
                                bookingListType: _bookingListType,
                                clubTeeTimeSlotList: clubTeeTimeSlots,
                                fromTime: _fromTime,
                                toTime: _toTime,
                                startDate: _forDate,
                                courseInfo: this.courseInfo,
                                clubInfo: this.clubInfo,
                                playerVoucher: playerVoucher,
                                playerId: _playerId,
                                fromClub: false,
                                searchDistance: this.searchDistance,
                                filterCountry: this.filterCountry,
                                filteredLocation: this.filteredLocation,
                              },
                            };
                            this.router.navigate(['booking-club-list'], navigationExtras);
                          } else {
                            navigationExtras = {
                              state: {
                                bookingListType: _bookingListType,
                                clubTeeTimeSlotList: clubTeeTimeSlots,
                                fromTime: _fromTime,
                                toTime: _toTime,
                                startDate: _forDate,
                                courseInfo: this.courseInfo,
                                clubInfo: this.clubInfo,
                                playerId: _playerId,
                                fromClub: false,
                                searchDistance: this.searchDistance,
                                filterCountry: this.filterCountry,
                                filteredLocation: this.filteredLocation,
                              },
                            };
                            this.router.navigate(['booking-club-list'], navigationExtras);
                          }
                          if (loader) loader.dismiss();
                        });
                    }
                  } else {
                    let _message =
                      this.clubInfo.clubName +
                      '<br>Date : ' +
                      _forDate +
                      '<br>From ' +
                      _fromTime +
                      ' to ' +
                      _toTime;
                    let alert = this.alertCtrl
                      .create({
                        header: 'Search by Single Club',
                        message: _message,
                        buttons: ['Close'],
                      })
                      .then(res => {
                        res.present();
                      });
                    loader.dismiss();
                  }
                },
                error => {
                  let _error = error;
                  if (error.status === 409) {
                    let _message = _error.errors[0];
                    let alert = this.alertCtrl
                      .create({
                        header: 'Search by Single Club',
                        message: _message,
                        buttons: ['Close'],
                      })
                      .then(res => {
                        res.present();
                      });
                  }
                  if (loader) loader.dismiss().then(() => {});
                },
                () => {
                  if (loader) loader.dismiss().then(() => {});
                }
              );
          });
        }
      } else if (_bookingListType === 'favClubs') {
        this.flightService.getTeeTimeSlotFavClubs(_forDate, _fromTime, _toTime).subscribe(
          (data: any) => {
            // clubTeeTimeSlots : Array<ClubTeeTimeSlots>
            // loader.dismiss().then(() => {
            if (data && data.teeTimeSlot) {
              let clubTeeTimeSlots: Array<ClubTeeTimeSlots> = data.teeTimeSlot;

              if (clubTeeTimeSlots.length > 0) {
                this.flightService
                  .getListPlayerVouchers(_playerId)
                  .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
                    if (playerVoucher && playerVoucher.length > 0) {
                      navigationExtras = {
                        state: {
                          bookingListType: _bookingListType,
                          clubTeeTimeSlotList: clubTeeTimeSlots,
                          fromTime: _fromTime,
                          toTime: _toTime,
                          startDate: _forDate,
                          courseInfo: this.courseInfo,
                          clubInfo: this.clubInfo,
                          playerVoucher: playerVoucher,
                          playerId: _playerId,
                          fromClub: false,
                          filterCountry: this.filterCountry,
                          filteredLocation: this.filteredLocation,
                        },
                      };
                      this.router.navigate(['booking-club-list'], navigationExtras);
                    } else {
                      navigationExtras = {
                        state: {
                          bookingListType: _bookingListType,
                          clubTeeTimeSlotList: clubTeeTimeSlots,
                          fromTime: _fromTime,
                          toTime: _toTime,
                          startDate: _forDate,
                          courseInfo: this.courseInfo,
                          clubInfo: this.clubInfo,
                          fromClub: false,
                          filterCountry: this.filterCountry,
                          filteredLocation: this.filteredLocation,
                        },
                      };
                      this.router.navigate(['booking-club-list'], navigationExtras);
                    }
                  });
              } else {
                let _message =
                  'No Tee Time slots for <br>Date : ' +
                  _forDate +
                  '<br>From ' +
                  _fromTime +
                  ' to ' +
                  _toTime;
                let alert = this.alertCtrl
                  .create({
                    header: 'Search by Favourite Club(s)',
                    message: _message,
                    buttons: ['Close'],
                  })
                  .then(res => {
                    res.present();
                  });
                if (loader) loader.dismiss().then(() => {});
              }
            }
            if (loader) loader.dismiss().then(() => {});
            // });
          },
          error => {
            let _error = error;
            if (error.status === 409) {
              let _message = _error.errors[0].includes('favorite clubs')
                ? 'No Favourite clubs found. Please tap on SET UP to define your favourites.'
                : _error.errors[0];
              let alert = this.alertCtrl
                .create({
                  header: 'Search by Favourite Club(s)',
                  message: _message,
                  buttons: ['Close'],
                })
                .then(res => {
                  res.present();
                });
            }
            if (loader) loader.dismiss().then(() => {});
          },
          () => {
            setTimeout(() => {
              if (loader) loader.dismiss().then(() => {});
            }, 5000);
          }
        );
      } else if (
        _bookingListType === 'allClubs' ||
        _bookingListType === 'location' ||
        _bookingListType === 'recentClubs'
      ) {
        let _serviceCall;
        // if(this.userType === 'player') _serviceCall = this.flightService.getListAllSlots(_playerId,_forDate,_fromTime,_toTime)
        // if(this.userType === 'booking_agent')
        let _pageSize = 5;
        let _partner = this.partnerInfo ? this.partnerInfo.id : null;
        // _serviceCall = this.flightService.getSearchAllSlots(
        //   _forDate,
        //   _fromTime,
        //   _toTime,
        //   _pageSize,
        //   null,
        //   _partner,
        //   null,
        //   _countryId,
        //   null,
        //   this.filteredLocation
        // );
        // loader.dismiss().then(() => {
        _serviceCall = this.flightService
          .getSearchAllSlots(
            _forDate,
            _fromTime,
            _toTime,
            _pageSize,
            null,
            _partner,
            null,
            _countryId,
            null,
            this.filteredLocation
          )
          .subscribe(
            async (data: any) => {
              // clubTeeTimeSlots : Array<ClubTeeTimeSlots>
              if (data && data.teeTimeSlot) {
                let _slotStats = data.resp;
                let clubTeeTimeSlots: Array<ClubTeeTimeSlots> = data.teeTimeSlot;

                if (clubTeeTimeSlots.length > 0) {
                  if (this.userType === 'player') {
                    this.flightService.getListPlayerVouchers(_playerId).subscribe(
                      (playerVoucher: Array<TeeTimeClubVoucher>) => {
                        if (playerVoucher && playerVoucher.length > 0) {
                          navigationExtras = {
                            state: {
                              bookingListType: _bookingListType,
                              clubTeeTimeSlotList: clubTeeTimeSlots,
                              fromTime: _fromTime,
                              toTime: _toTime,
                              startDate: _forDate,
                              courseInfo: this.courseInfo,
                              clubInfo: this.clubInfo,
                              playerVoucher: playerVoucher,
                              playerId: _playerId,
                              fromClub: false,
                              partnerInfo: this.partnerInfo,
                              totalPages: _slotStats.totalPages,
                              filterCountry: this.filterCountry,
                              filteredLocation: this.filteredLocation,
                            },
                          };
                          this.router.navigate(['booking-club-list'], navigationExtras);
                        } else {
                          navigationExtras = {
                            state: {
                              bookingListType: _bookingListType,
                              clubTeeTimeSlotList: clubTeeTimeSlots,
                              fromTime: _fromTime,
                              toTime: _toTime,
                              startDate: _forDate,
                              courseInfo: this.courseInfo,
                              clubInfo: this.clubInfo,
                              playerId: _playerId,
                              fromClub: false,
                              partnerInfo: this.partnerInfo,
                              totalPages: _slotStats.totalPages,
                              filterCountry: this.filterCountry,
                              filteredLocation: this.filteredLocation,
                            },
                          };
                          this.router.navigate(['booking-club-list'], navigationExtras);
                        }
                      },
                      error => {
                        // navigationExtras = {
                        //   state: {
                        //     bookingListType: _bookingListType,
                        //     clubTeeTimeSlotList: clubTeeTimeSlots,
                        //     fromTime: _fromTime,
                        //     toTime: _toTime,
                        //     startDate: _forDate,
                        //     courseInfo: this.courseInfo,
                        //     clubInfo: this.clubInfo,
                        //     playerId: _playerId,
                        //     fromClub: false,
                        //     partnerInfo: this.partnerInfo,
                        //     totalPages: _slotStats.totalPages,
                        //     filterCountry: this.filterCountry,
                        //     filteredLocation: this.filteredLocation,
                        //   }
                        // };
                        // this.router.navigate(
                        //   ['booking-club-list'],
                        //   navigationExtras
                        // );
                      }
                    );
                  } else {
                    navigationExtras = {
                      state: {
                        bookingListType: _bookingListType,
                        clubTeeTimeSlotList: clubTeeTimeSlots,
                        fromTime: _fromTime,
                        toTime: _toTime,
                        startDate: _forDate,
                        courseInfo: this.courseInfo,
                        clubInfo: this.clubInfo,
                        // playerId: _playerId,
                        fromClub: false,
                        userType: this.userType,
                        partnerInfo: this.partnerInfo,
                        totalPages: _slotStats.totalPages,
                        filterCountry: this.filterCountry,
                        filteredLocation: this.filteredLocation,
                      },
                    };
                    this.router.navigate(['booking-club-list'], navigationExtras);
                  }
                } else {
                  let _message =
                    'No Tee Time slots for <br>Date : ' +
                    _forDate +
                    '<br>From ' +
                    _fromTime +
                    ' to ' +
                    _toTime;
                  if (this.filterCountry && this.filterCountry.name)
                    _message += '<br>Country : ' + this.filterCountry.name;
                  let alert = await this.modalCtl.create({
                    component: DeleteRoomModalComponent,
                    showBackdrop: true,
                    mode: 'ios',
                    cssClass: this.platform.is('mobile')
                      ? 'self-adjustable-modal'
                      : 'self-adjustable-modal-desktop',
                    componentProps: {
                      header: 'Search by All Club(s)',
                      msg: _message,
                      mode: 'serachByAllClub',
                    },
                  });
                  await alert.present().then(() => {
                    const height = this.platform.height() - 180;
                    document.getElementsByClassName('inner-content')[0]['style'].maxHeight =
                      `${height}px`;
                  });
                }
              }
              if (loader) loader.dismiss().then(() => {});
              if (_serviceCall) {
                _serviceCall.unsubscribe();
                _serviceCall = null;
              }
            },
            error => {
              let _error = error;
              if (error.status === 409) {
                let _message = _error.errors[0].includes('favorite clubs')
                  ? 'No Favourite clubs found. Please tap on SET UP to define your favourites.'
                  : _error.errors[0];
                let alert = this.alertCtrl
                  .create({
                    header: 'Search by Favourite Club(s)',
                    message: _message,
                    buttons: ['Close'],
                  })
                  .then(res => {
                    res.present();
                  });
              }
              if (loader) loader.dismiss().then(() => {});
              if (_serviceCall) {
                _serviceCall.unsubscribe();
                _serviceCall = null;
              }
            }
            // complete: () => {
            // setTimeout(() => {
            //   loader.dismiss();
            // }, 5000)
            // },
          );
        // });
      }
    });
    // 310510219 afamosa course id
  }

  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data
          .filter(d => {
            return d.page === 'bookingHome';
          })
          .map(d => {
            this.appAttribute = d;
          });
        if (
          (!this.searchCriteria || this.searchCriteria === undefined) &&
          this.appAttribute.filters
        ) {
          this.fromTime = this.appAttribute.filters.fromTime;
          this.toTime = this.appAttribute.filters.toTime;
          if (!this.isClubSpecific && this.userType !== 'booking_agent')
            this.selectClubType = this.appAttribute.filters.selectClubType;
        }
      }
    });
  }

  refreshFavouriteClubs() {
    this.favClubs = [];
    this.playerService.getFavoriteClubs(false).subscribe(
      (favourites: any) => {
        this.favClubs = favourites;
      },
      error => {},
      () => {}
    );
  }

  onLoadingBookingClubListPage(navigationExtras: NavigationExtras) {
    this.router.navigate(['booking-club-list'], navigationExtras);
  }

  getClubAddress() {
    if (!this.clubInfo) return;
    if (typeof this.clubInfo?.address === 'string') return this.clubInfo?.address;
    else
      return `${this.clubInfo?.address?.city}, ${this.clubInfo?.address?.state}, ${this.clubInfo?.address?.countryData?.name}`;
  }
}
